import { render, staticRenderFns } from "./servicedetail.vue?vue&type=template&id=41a8a82e&scoped=true&"
import script from "./servicedetail.vue?vue&type=script&lang=js&"
export * from "./servicedetail.vue?vue&type=script&lang=js&"
import style0 from "./servicedetail.vue?vue&type=style&index=0&id=41a8a82e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a8a82e",
  null
  
)

export default component.exports